import React from "react";

const Error = () => {
    return (
        <React.Fragment>
            <div className="row justify-content-center mt-5">
                <div className="col-6 mt-5 text-center">
                    <h1 style={{ color: "#91B8C1" }}><i className="fad fa-dizzy" style={{ color: "#FF7C1F"}}></i>  Something went wrong!?!</h1>
                    <p className="mt-5">Unfortunately something just went a bit wonky! It's been logged and we'll look into it.</p>
                    <p>If you have any concerns drop us an email... admin@justgoride.co.uk</p>
                </div>
            </div>
            </React.Fragment>
        )
}

    

export default Error; 


// WEBPACK FOOTER //
// ./src/components/Error.js